const state = {
    // menuRoutes: [],
    user: {
        userName: '',
        token: ''
    },
    event: '',
    disabled: '',
    navList: [
        {
            name: '试验项目',
            path: '/project',
            content: '新建/打开/保存/导出试验信息，生成试验',
            btnList: [
                'addNewEp',
                'openEP',
                'preserveEpInfo',
                'saveAsEpInfo',
                'GeneratingEpInfo',
                'DummyTempDown'
            ]
        },
        {
            name: '信号检查',
            needID: true,
            path: '/signal',
            content: '检测软硬件连接情况与传感器数值',
            btnList: [
                'detectionHardware',
                'checkEquipmentStatus',
                {
                    type: 'switch',
                    options: ['displayValues', 'hiddenValues']
                }
            ]
        },
        {
            name: '试验视图',
            needID: true,
            path: '/experimentView',
            content: '以曲线图/字母/3D模型的形式展示实时数据',
            btnList: [
                // {
                //     type: 'switch',
                //     options: ['display', 'hidden']
                // },
                {
                    type: 'switch',
                    options: ['preserveEp', 'stopEp']
                },
                'newPage',
                {
                    type: 'select',
                    title: '图表',
                    options: [
                        'newYTChat',
                        'NewAlphabet',
                        'NewSJModel',
                        'NewCKModel'
                    ]
                },
                {
                    type: 'switch',
                    options: ['fullScreen', 'quitFullScreen']
                },
                {
                    type: 'switch',
                    options: ['hiddenTree', 'showTree']
                }
            ]
        },
        {
            name: '数据管理',
            path: '/dataManagement',
            content: '加载/导出服务器中存储的历史数据',
            btnList: [
                'load',
                'wipeData',
                'export',
                {
                    type: 'switch',
                    options: ['hiddenTree', 'showTree']
                }
            ]
        },
        {
            name: 'CFD舒适性计算',
            path: '/comfortCompute',
            content: '计算热舒适、热感觉',
            btnList: [
                'import',
                'wipeData',
                'export',
                'comfortComputBtn',
                {
                    type: 'switch',
                    options: ['hiddenTree', 'showTree']
                }
            ]
        },
        {
            name: '数据分析',
            path: '/dataAnalysis',
            content: '导入本地数据文件',
            btnList: [
                'import',
                'wipeData',
                'newPage',
                {
                    type: 'select',
                    title: '图表',
                    options: [
                        'newYTChat',
                        'NewAlphabet',
                        'NewSJModel',
                        'NewCKModel'
                    ]
                },
                {
                    type: 'switch',
                    options: ['hiddenTree', 'showTree']
                },
                'screenshot'
            ]
        },
        {
            name: '分析报告',
            path: '/dataReport',
            content: '生成分析报告，导出PDF',
            btnList: [
                'generatingReports',
                'exportPDF'
            ]
        },
        {
            name: '系统信息',
            content: '测试文字',
            btnList: [
                'addNewEp',
                'saveAsEpInfo'
            ]
        },
        {
            name: '信息',
            path: '/manData',
            content: '信息',
            btnList: [
                'run',
                'doctor',
                'man',
                'password',
                {
                    type: 'switch',
                    options: ['hiddenTree', 'showTree']
                }
            ]
        },
    ]
};
export default state;



// WEBPACK FOOTER //
// ./src/store/state.js